/**
 * JinnyJoes – Filter-Gruppierung (mehrsprachig, v5)
 * assets/jinnyjoes-filter-groups.js
 *
 * Matching-Reihenfolge (intern) ≠ Anzeige-Reihenfolge (sichtbar).
 * Spezifische Gruppen werden intern zuerst geprüft (verhindert Fehlzuordnungen),
 * aber die Anzeige folgt dem "displayOrder"-Wert.
 *
 * v5: Gruppierung wird nur noch auf den "Type"-Filter angewendet,
 *     andere Filter (z. B. Material) bleiben unangetastet.
 */

(function () {

  // ─── SPRACHERKENNUNG ──────────────────────────────────────────────────────
  function detectLang() {
    const htmlLang = (document.documentElement.lang || "").toLowerCase().slice(0, 2);
    if (["de", "en", "fr", "it"].includes(htmlLang)) return htmlLang;
    const path = window.location.pathname.toLowerCase();
    if (path.includes("/fr/") || path.startsWith("/fr")) return "fr";
    if (path.includes("/it/") || path.startsWith("/it")) return "it";
    if (path.includes("/en/") || path.startsWith("/en")) return "en";
    return "de";
  }

  // ─── ZIEL-FILTER (nur "Type/Typ" gruppieren) ──────────────────────────────
  const TYPE_FILTER_LABELS = {
    de: ["typ", "type", "produkttyp", "art"],
    en: ["type", "product type"],
    fr: ["type", "type de produit"],
    it: ["tipo", "tipologia", "tipo di prodotto"],
  };

  // ─── GRUPPEN ──────────────────────────────────────────────────────────────
  // matchOrder: Intern-Reihenfolge für korrekte Zuordnung (spezifisch zuerst)
  // displayOrder: Sichtbare Reihenfolge für den Kunden
  const GROUPS = [

    {
      displayOrder: 3,  // Anzeige: 3. Position
      label: { de: "Löffel", en: "Spoons", fr: "Cuillères", it: "Cucchiai" },
      keywords: {
        de: ["löffel", "besteck", "salatbesteck", "kochlöffel", "gabel", "messer"],
        en: ["spoon", "spoons", "cutlery", "salad server", "cooking spoon", "fork", "knife"],
        fr: ["cuillère", "cuillères", "couverts", "salade", "fourchette", "couteau"],
        it: ["cucchiaio", "cucchiaini", "posate", "insalata", "forchetta", "coltello"],
      },
    },

    {
      displayOrder: 4,  // Anzeige: 4. Position
      label: { de: "Servieren & Küchenzubehör", en: "Serving & Kitchen", fr: "Service & Cuisine", it: "Servizio & Cucina" },
      keywords: {
        de: ["eierbecher", "eierhalter", "servierplatt", "servierbrett", "schneidebrett",
             "kuchenständer", "tortenständer", "utensilienhalter", "butterdose",
             "essig", "salz & pfeffer", "salz-", "pfeffermühl", "pfeffer streuer",
             "untersetzer", "tischset", "milchkännchen", "saucenkännchen", "teekrug",
             "zuckerdose", "teeeier", "messbecher", "menagen", "serviettenhalter",
             "flaschenkühl", "weinkühl", "drehteller", "giesskannen", "krug",
             "karaffe & krug", "salatbesteck"],
        en: ["egg cup", "egg holder", "serving plate", "serving board", "cutting board",
             "cake stand", "utensil holder", "butter dish", "vinegar", "salt & pepper",
             "pepper mill", "coaster", "placemat", "milk jug", "sauce jug", "teapot",
             "sugar bowl", "tea infuser", "measuring cup", "condiment", "napkin holder",
             "bottle cooler", "watering can", "jug", "carafe & jug"],
        fr: ["coquetier", "porte-œuf", "plateau de service", "planche", "présentoir",
             "porte-ustensiles", "beurrier", "sel & poivre", "moulin", "poivrier",
             "dessous de verre", "set de table", "théière", "sucrier", "infuseur",
             "gobelets gradués", "ménages", "porte-serviettes", "arrosoir", "pichet"],
        it: ["portauova", "piatto da portata", "tagliere", "alzata", "portautensili",
             "burriera", "sale & pepe", "macinino", "saliera", "sottobicchieri",
             "tovagliette", "teiera", "zuccheriera", "infusori", "misurini",
             "set per condimenti", "portatovaglioli", "annaffiatoio", "brocca"],
      },
    },

    {
      displayOrder: 6,  // Anzeige: 6. Position
      label: { de: "Deko & Wohnen", en: "Decor & Living", fr: "Déco & Maison", it: "Decorazioni & Casa" },
      keywords: {
        de: ["vase", "vasen", "blumentopf", "blument", "deko", "dekoobjekte", "dekohänger",
             "dekofliesen", "kranz", "kränze", "haken", "leisten", "wandregal", "wandhaken",
             "magnet", "holzdeko", "baumschmuck", "holzschriftzug", "holzanh", "papierdeko",
             "kartenständer", "blumenständer", "blumen- und", "lichthäuser", "lichthaus",
             "windlicht", "streichhölzer"],
        en: ["vase", "vases", "flower pot", "decor", "decoration", "decorative hanger",
             "wreath", "hook", "rail", "shelf", "wall hook", "magnet", "wooden decor",
             "tree decoration", "wooden lettering", "paper decor", "card holder",
             "flower stand", "lighted house", "lantern", "matches"],
        fr: ["vase", "vases", "pot de fleur", "déco", "décoration", "suspension déco",
             "couronne", "crochet", "barre", "étagère", "crochet mural", "aimant",
             "déco en bois", "décoration pour le sapin", "inscription en bois",
             "déco en papier", "présentoir fleurs", "maison lumineuse", "photophore", "allumette"],
        it: ["vaso", "vasi", "fioriera", "decorazione", "decorazioni", "decorazione da appendere",
             "ghirlanda", "gancio", "barre", "scaffale", "gancio da parete", "magnete",
             "decorazioni in legno", "decorazioni per l'albero", "scritte in legno",
             "decorazioni di carta", "portafiori", "case con luce", "lanterna", "fiammiferi"],
      },
    },

    {
      displayOrder: 10,
      label: { de: "Servietten", en: "Napkins", fr: "Serviettes de Table", it: "Tovaglioli" },
      keywords: {
        de: ["serviette", "servietten", "cocktailservietten", "lunchservietten",
             "buffetservietten", "leinenservietten"],
        en: ["napkin", "napkins", "cocktail napkin", "lunch napkin",
             "buffet napkin", "linen napkin"],
        fr: ["serviette cocktail", "serviette déjeuner", "serviette buffet",
             "serviettes en lin", "serviettes de table"],
        it: ["tovagliolo da cocktail", "tovagliolo da pranzo", "tovagliolo da buffet",
             "tovaglioli di lino", "tovaglioli"],
      },
    },

    {
      displayOrder: 12,
      label: { de: "Bettwäsche & Kissen", en: "Bedding & Cushions", fr: "Linge de Lit & Coussins", it: "Biancheria & Cuscini" },
      keywords: {
        de: ["bettwäsche", "kissenbezug", "zierkissenbezug", "duvetbezug", "duvetbezüge", "duvet", "zierkissen",
             "plaid", "lavendelkissen", "zirbenkissen", "kirschkernkissen"],
        en: ["bedding", "cushion cover", "decorative cushion cover", "duvet cover",
             "decorative cushion", "plaid", "lavender pillow", "stone pine pillow"],
        fr: ["parure de lit", "housse de coussin", "housse de duvet", "coussin décoratif",
             "plaid", "coussin de lavande", "coussin en pin cembro"],
        it: ["biancheria da letto", "fodera per cuscino", "copripiumino", "cuscino decorativo",
             "plaid", "cuscino alla lavanda", "cuscino in pino cembro"],
      },
    },

    {
      displayOrder: 15,
      label: { de: "Papeterie & Büro", en: "Stationery & Office", fr: "Papeterie & Bureau", it: "Cartoleria & Ufficio" },
      keywords: {
        de: ["notizblock", "notizblöcke", "notizbuch", "büroaccessoire", "schreibtischunterlage",
             "stift", "stifte", "postkarte", "grußkarte", "grusskarte", "spielblock", "spiele",
             "sticker", "federmäppchen", "portemonnaie", "kalender", "messlatten"],
        en: ["notepad", "notebook", "office accessory", "desk pad", "pen", "pens",
             "postcard", "greeting card", "games", "sticker", "pencil case", "wallet",
             "calendar", "height chart"],
        fr: ["bloc-notes", "carnet", "accessoire de bureau", "stylo", "carte postale",
             "carte de vœux", "jeux", "autocollant", "trousse", "portefeuille",
             "calendrier", "toise"],
        it: ["blocco note", "quaderno", "accessorio ufficio", "penna", "penne",
             "cartolina", "biglietto d'auguri", "giochi", "adesivo", "astuccio",
             "portafoglio", "calendario", "metro di crescita"],
      },
    },

    // ── Allgemeinere Gruppen mit displayOrder ───────────────────────────────

    {
      displayOrder: 1,  // ← Tassen ganz oben
      label: { de: "Tassen", en: "Cups", fr: "Tasses", it: "Tazze" },
      keywords: {
        de: ["tasse", "cappuccino", "latte macchiato", "tassendeckel"],
        en: ["cup", "cups", "cappuccino", "latte macchiato", "cup lid"],
        fr: ["tasse", "cappuccino", "latte macchiato", "couvercle de tasse"],
        it: ["tazza", "tazze", "cappuccino", "latte macchiato"],
      },
    },

    {
      displayOrder: 2,  // ← Becher direkt nach Tassen
      label: { de: "Becher", en: "Mugs", fr: "Gobelets", it: "Boccali" },
      keywords: {
        // "Eierbecher" wird von Servieren & Küche weiter oben abgefangen
        de: ["becher"],
        en: ["mug", "mugs"],
        fr: ["gobelet", "gobelets"],
        it: ["boccale", "boccali"],
      },
    },

    {
      displayOrder: 5,
      label: { de: "Glas", en: "Glasses & Carafes", fr: "Verres & Carafes", it: "Bicchieri & Caraffe" },
      keywords: {
        de: ["wassergl", "weingl", "sektgl", "champagnergl", "espressogl", "teegl",
             "latte macchiatogl", "doppelwandige gl", "bubble gl", "cangläser",
             "trinkgläser", "glasdeckel", "karaffen & krüge", "karaffe", "strohhalm"],
        en: ["water glass", "wine glass", "champagne glass", "espresso glass", "tea glass",
             "latte macchiato glass", "double-walled glass", "bubble glass", "can glass",
             "drinking glass", "glass lid", "carafe"],
        fr: ["verre à eau", "verre à vin", "flûte", "verre à espresso", "verre à thé",
             "verre à latte", "verre à double paroi", "verre bubble", "verre canette",
             "couvercle en verre", "carafe"],
        it: ["bicchiere da acqua", "bicchiere da vino", "bicchiere da spumante",
             "bicchiere da espresso", "bicchiere da tè", "bicchiere da latte",
             "bicchiere a doppia parete", "bicchiere bubble", "bicchiere a lattina",
             "coperchio in vetro", "caraffa"],
      },
    },

    {
      displayOrder: 7,
      label: { de: "Teller", en: "Plates", fr: "Assiettes", it: "Piatti" },
      keywords: {
        de: ["teller", "tellersets"],
        en: ["plate", "plates", "plate set"],
        fr: ["assiette", "assiettes", "set d'assiettes"],
        it: ["piatto", "piatti", "set di piatti"],
      },
    },

    {
      displayOrder: 8,
      label: { de: "Schalen & Schüsseln", en: "Bowls", fr: "Bols & Coupelles", it: "Ciotole" },
      keywords: {
        de: ["schale", "schalen", "müslischalen", "müesli", "suppenschal", "suppentasse",
             "glasschalen", "aperoschalen", "dip-"],
        en: ["bowl", "bowls", "cereal bowl", "soup bowl", "glass bowl", "dip bowl"],
        fr: ["bol", "bols", "coupelle", "céréale", "soupe", "bol en verre", "dip"],
        it: ["ciotola", "ciotole", "cereali", "zuppa", "ciotola in vetro", "dip"],
      },
    },

    {
      displayOrder: 9,
      label: { de: "Vorratsdosen & Aufbewahrung", en: "Storage", fr: "Rangement & Conservation", it: "Conservazione & Contenitori" },
      keywords: {
        de: ["vorratsdose", "vorratsgl", "aufbewahrung", "brotbeutel", "körbe",
             "leinenbeutel", "aufbewahrungskorb", "aufbewahrungsbeutel"],
        en: ["storage tin", "storage jar", "storage", "basket", "linen bag"],
        fr: ["boîte de conservation", "bocaux", "rangement", "panier", "sac en lin"],
        it: ["contenitore di conservazione", "barattolo", "conservazione", "cesti"],
      },
    },

    {
      displayOrder: 11,
      label: { de: "Küchentextilien & Handtücher", en: "Kitchen Textiles & Towels", fr: "Linge de Cuisine & Serviettes", it: "Tessili da Cucina & Asciugamani" },
      keywords: {
        de: ["geschirrtuch", "geschirrtücher", "schwammtuch", "schwammtücher",
             "wischtuch", "wischtücher", "topflappen", "schürze",
             "handtuch", "handtücher", "tischläufer", "tischtuch"],
        en: ["tea towel", "sponge cloth", "cleaning cloth", "potholder", "apron",
             "towel", "towels", "table runner", "tablecloth"],
        fr: ["torchon", "lavette", "chiffon", "manique", "tablier",
             "serviette de bain", "chemin de table", "nappe"],
        it: ["strofinaccio", "panno spugna", "panno per pulizia", "presina", "grembiule",
             "asciugamano", "asciugamani", "runner da tavola", "tovaglia"],
      },
    },

    {
      displayOrder: 13,
      label: { de: "Bad & Körperpflege", en: "Bathroom & Body Care", fr: "Salle de Bain & Soins", it: "Bagno & Cura del Corpo" },
      keywords: {
        de: ["seifenspender", "lotionspender", "bad aufbewahrung", "keramikablagen", "duft", "körperpflege"],
        en: ["soap dispenser", "lotion dispenser", "bathroom storage", "ceramic tray", "fragrance", "body care"],
        fr: ["distributeur de savon", "rangement salle de bain", "plateau en céramique", "parfum", "soins du corps"],
        it: ["dispenser per sapone", "contenitori per il bagno", "vassoi in ceramica", "profumo", "cura del corpo"],
      },
    },

    {
      displayOrder: 14,
      label: { de: "Kerzen & Licht", en: "Candles & Lights", fr: "Bougies & Lumières", it: "Candele & Luci" },
      keywords: {
        de: ["kerze", "kerzen", "stabkerze", "blockkerze", "teelicht", "kerzenhalter", "kerzenständer"],
        en: ["candle", "candles", "taper candle", "pillar candle", "tealight", "candle holder"],
        fr: ["bougie", "bougies", "chandelle", "bougie cylindrique", "bougeoir"],
        it: ["candela", "candele", "candela a stelo", "candela a cilindro", "portacandele"],
      },
    },

    {
      displayOrder: 3,  // ← Tee auf Position 3 (nach Becher)
      label: { de: "Tee", en: "Tea", fr: "Thé", it: "Tè" },
      keywords: {
        de: ["teebären", "teebär", "tee "],
        en: ["tea bear", " tea ", " tea,"],
        fr: ["oursons à thé", " thé ", " thé,"],
        it: ["orsetti da tè", " tè ", " tè,"],
      },
    },

    {
      displayOrder: 16,
      label: { de: "Fussmatten & Teppiche", en: "Doormats & Rugs", fr: "Paillassons & Tapis", it: "Zerbini & Tappeti" },
      keywords: {
        de: ["fussmatte", "fussmatten", "teppich", "läufer"],
        en: ["doormat", "doormats", "rug", "runner"],
        fr: ["paillasson", "paillassons", "tapis"],
        it: ["zerbino", "zerbini", "tappeto"],
      },
    },

    {
      displayOrder: 17,
      label: { de: "Taschen & Shopper", en: "Bags & Shoppers", fr: "Sacs & Cabas", it: "Borse & Shopper" },
      keywords: {
        de: ["tasche", "taschen", "shopper", "beutel", "kühltasche", "kosmetiktasche"],
        en: ["bag", "bags", "tote bag", "cooler bag", "make-up bag"],
        fr: ["sac", "sacs", "sac cabas", "sac isotherme", "trousse"],
        it: ["borsa", "borse", "borse shopper", "borsa termica", "porta cosmetici"],
      },
    },

    {
      displayOrder: 18,
      label: { de: "Kleidung & Accessoires", en: "Clothing & Accessories", fr: "Vêtements & Accessoires", it: "Abbigliamento & Accessori" },
      keywords: {
        de: ["socken", "hoodie", "ohrring", "ohrstecker", "halskette", "armband",
             "schlüsselanhänger", "haarspange", "kamm", "kämme"],
        en: ["sock", "socks", "hoodie", "earring", "necklace", "bracelet", "key ring", "hair clip", "comb"],
        fr: ["chaussette", "hoodie", "boucle d'oreille", "collier", "bracelet", "porte-clés", "barrette"],
        it: ["calzino", "calzini", "hoodie", "orecchino", "collana", "braccialetto", "portachiavi"],
      },
    },

    {
      displayOrder: 19,
      label: { de: "Geschenkideen", en: "Gift Ideas", fr: "Idées Cadeaux", it: "Idee Regalo" },
      keywords: {
        de: ["geschenkideen", "geschenkbox", "geschenktasche", "geschenkverpackung", "gutschein"],
        en: ["gift idea", "gift box", "gift bag", "gift packaging", "voucher"],
        fr: ["idée cadeau", "coffret cadeau", "sac cadeau", "emballage cadeau", "bon cadeau"],
        it: ["idea regalo", "scatola regalo", "sacchetto regalo", "confezione regalo", "buono"],
      },
    },

    {
      displayOrder: 99, // Sonstiges immer zuletzt
      label: { de: "Sonstiges", en: "Other", fr: "Autres", it: "Altro" },
      keywords: { de: [], en: [], fr: [], it: [] },
    },
  ];

  // ─── STYLING ──────────────────────────────────────────────────────────────
  const CSS = `
    .jj-filter-group-label {
      font-size: 14px;
      font-weight: 600;
      text-transform: uppercase;
      letter-spacing: 0.07em;
      color: #AB9379;
      margin: 14px 0 4px;
      padding-bottom: 5px;
      border-bottom: 1px solid #d9c9b0;
      display: block;
      list-style: none;
    }
    .jj-filter-group-label:first-child {
      margin-top: 2px;
    }
  `;

  // ─── LOGIK ────────────────────────────────────────────────────────────────

  function injectStyles() {
    if (document.getElementById("jj-filter-styles")) return;
    const style = document.createElement("style");
    style.id = "jj-filter-styles";
    style.textContent = CSS;
    document.head.appendChild(style);
  }

  function getGroupIndex(text, lang) {
    const lower = text.toLowerCase();
    for (let i = 0; i < GROUPS.length - 1; i++) {
      const kws = GROUPS[i].keywords[lang] || GROUPS[i].keywords["de"];
      if (kws.some((kw) => lower.includes(kw))) return i;
    }
    return GROUPS.length - 1;
  }


function normalizeFilterTitle(text) {
  return (text || "")
    .replace(/\s+/g, " ")
    .trim()
    .toLowerCase()
    .replace(/\s*\(\d+\)\s*$/, "")
    .trim();
}

// Prüft, ob der gegebene <ul>-Parent zum "Type/Typ"-Filter gehört.
function isTypeFilter(parent, lang) {
  const labels = TYPE_FILTER_LABELS[lang] || TYPE_FILTER_LABELS["de"];

  // 1. Sicherste Erkennung: dein Shopify-Metafield-Filter heisst filter.p.m.custom.typ
  const group = parent.closest(
    ".collection__filter-group, details, .filter-group, .facets__disclosure"
  );

  if (!group) return false;

  if (
    group.querySelector(
      "input[name='filter.p.m.custom.typ'], " +
      "input[name='filter.p.product_type'], " +
      "input[id*='filter.p.m.custom.typ'], " +
      "input[id*='filter.p.product_type']"
    )
  ) {
    return true;
  }

  // 2. Fallback: Überschrift lesen
  const heading = group.querySelector(
    ".collection__filter-group-name, " +
    "button.collection__filter-group-name, " +
    "summary, legend, h2, h3, h4, " +
    ".filter-title, .collection__filter-title, " +
    "[class*='filter-title'], [class*='facet-title']"
  );

  if (!heading) return false;

  const text = normalizeFilterTitle(heading.textContent);

  return labels.some((label) => {
    const normalizedLabel = normalizeFilterTitle(label);
    return text === normalizedLabel || text.startsWith(normalizedLabel + " ");
  });
}

  function groupFilters() {
    const lang = detectLang();
    const allItems = Array.from(
      document.querySelectorAll("li.collection__filter-checkbox")
    ).filter((el) => !el.closest("[data-jj-grouped]"));

    if (allItems.length < 2) return;

    const containers = new Set();
    allItems.forEach((item) => containers.add(item.parentNode));

    containers.forEach((parent) => {
      // ⬇ NEU: Nur den "Type"-Filter gruppieren, andere Filter (Material, Preis …) unangetastet lassen
      if (!isTypeFilter(parent, lang)) return;

      const items = Array.from(
        parent.querySelectorAll("li.collection__filter-checkbox")
      );
      if (items.length < 2) return;

      // Matching: intern nach Array-Reihenfolge (spezifisch zuerst)
      const buckets = GROUPS.map(() => []);
      items.forEach((item) => {
        const label = item.querySelector("label");
        const text = label ? label.textContent.trim() : item.textContent.trim();
        const idx = getGroupIndex(text, lang);
        buckets[idx].push(item);
      });

      const filledBuckets = buckets.filter((b) => b.length > 0);
      if (filledBuckets.length <= 1) return;

      parent.setAttribute("data-jj-grouped", "true");
      items.forEach((item) => item.remove());

      // Anzeige: nach displayOrder sortieren
      const orderedBuckets = buckets
        .map((bucket, i) => ({ bucket, group: GROUPS[i] }))
        .filter(({ bucket }) => bucket.length > 0)
        .sort((a, b) => a.group.displayOrder - b.group.displayOrder);

      orderedBuckets.forEach(({ bucket, group }) => {
        const heading = document.createElement("li");
        heading.className = "jj-filter-group-label";
        heading.textContent = group.label[lang] || group.label["de"];
        parent.appendChild(heading);
        bucket.forEach((item) => parent.appendChild(item));
      });
    });
  }

  function init() {
    injectStyles();
    groupFilters();
  }

  function startObserver() {
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.addedNodes.length > 0) {
          const hasFilterItems = Array.from(mutation.addedNodes).some(
            (node) =>
              node.nodeType === 1 &&
              (node.classList?.contains("collection__filter-checkbox") ||
                node.querySelector?.("li.collection__filter-checkbox"))
          );
          if (hasFilterItems) {
            setTimeout(groupFilters, 50);
            break;
          }
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => { init(); startObserver(); });
  } else {
    init();
    startObserver();
  }

  document.addEventListener("shopify:section:load", groupFilters);

})();